import { render } from "./ViewBonLivraison.vue?vue&type=template&id=c74a0ec8&scoped=true&ts=true"
import script from "./ViewBonLivraison.vue?vue&type=script&lang=ts"
export * from "./ViewBonLivraison.vue?vue&type=script&lang=ts"

import "./ViewBonLivraison.vue?vue&type=style&index=0&id=c74a0ec8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74a0ec8"]])

export default __exports__